import { createContext, useContext, useEffect, useState } from "react";

import {
  callErrorToast,
  callSuccessToast,
  modalDefault,
} from "../../../utilities";
import { OrdersService } from "../../../services/logistic/orders";
import { useAppContext } from "../../../AppProvider";
import { faChevronDoubleRight } from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { useHandlerOrderContext } from "../../Orders/providers/Handler";

const IndexOrderDetailsContext = createContext();

const ordersService = new OrdersService();

const IndexOrderDetailsProvider = ({
  children,
  parentId,
  callback,
  action,
}) => {
  const { dictionary, accessTokenPayload } = useAppContext();

  const handlerOrderContext = useHandlerOrderContext();

  const [orderDetail, setOrderDetail] = useState();
  const [orderDetailError, setOrderDetailError] = useState(null);
  const [orderDetailLoader, setOrderDetailLoader] = useState(false);

  const [modal, setModal] = useState({
    ...modalDefault,
  });

  const onExportCSV = () => {
    const orderDetails = handlerOrderContext.order.orderDetails || [];
    const headers = [
      dictionary.registries.name,
      dictionary.products.barcodes,
      dictionary.dimensions.quantity,
      dictionary.dimensions.unit_weight,
      dictionary.dimensions.total_weight,
      dictionary.words.unit_price,
      dictionary.words.discount,
      dictionary.words.total_price,
      dictionary.words.vat,
    ];
    const rows = orderDetails.map((item) => [
      item.articleName || "",
      item.barcode || "",
      item.quantity || "",
      item.unitWeight || "",
      item.totalWeight || "",
      item.unitPrice || "",
      item.discount || "",
      item.totalPrice || "",
      item.vat || "",
    ]);
    const csvContent = [headers, ...rows]
      .map((row) =>
        row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","),
      )
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "order_details_export" + ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const nextDetail = (openModal = false) => {
    setOrderDetailLoader(true);
    ordersService
      .nextDetail(parentId)
      .then((res) => {
        setOrderDetailLoader(false);
        if (res.status === 200 || openModal) {
          setModal({
            ...modal,
            title: `${
              dictionary.actions.complete
            } ${dictionary.products.product.toLowerCase()}`,
            icon: faChevronDoubleRight,
            open: true,
            size: "lg",
            action: "process",
            id: res.data,
          });
          return;
        }
        handlerOrderContext?.setCreateShipmentEnabled(true);
        callSuccessToast(
          {
            ...res,
            message: dictionary.products.all_products_are_completed,
          },
          dictionary,
        );
      })
      .catch((err) => {
        setOrderDetailLoader(false);
        setOrderDetailError(err);
      });
  };

  useEffect(() => {
    if (orderDetailError) {
      callErrorToast(orderDetailError, dictionary);
    }
  }, [orderDetailError]);

  useEffect(() => {
    if (
      action === "details" &&
      handlerOrderContext.order.lastStatus === "PROCESSING" &&
      accessTokenPayload.owner === "7f8625b9-973b-4c66-80af-346b49cde2e7"
    ) {
      //allabox senders
      nextDetail();
    }
  }, [handlerOrderContext.order.lastStatus]);

  return (
    <IndexOrderDetailsContext.Provider
      value={{
        orderDetail,
        orderDetailError,
        orderDetailLoader,
        nextDetail,

        onExportCSV,

        callback,

        action,
        parentId,
        modal,
        setModal,
      }}
    >
      {children}
    </IndexOrderDetailsContext.Provider>
  );
};

const useIndexOrderDetailsContext = () => {
  return useContext(IndexOrderDetailsContext);
};

export { IndexOrderDetailsProvider, useIndexOrderDetailsContext };
